// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const EmissionsPartSearchButtonGroup = props => {

    const canExecuteReport = props.partNumber !== '';

    return (
        <div className='emissions-part-search-button-group'>
            <button
                className='secondary-button'
                onClick={props.onCriteriaReset}
                type='submit'
            >
                <FormattedMessage id='RESET'/>
            </button>
            <button
                className='primary-button'
                disabled={!canExecuteReport}
                onClick={props.onPartSearchExecute}
                type='submit'
            >
                <FormattedMessage id='EXECUTE'/>
            </button>
        </div>
    );

};

EmissionsPartSearchButtonGroup.displayName = 'EmissionsPartSearchButtonGroup';
EmissionsPartSearchButtonGroup.propTypes = {
    onCriteriaReset: PropTypes.func.isRequired,
    onPartSearchExecute: PropTypes.func.isRequired,
    partNumber: PropTypes.string.isRequired
};

export default EmissionsPartSearchButtonGroup;



// WEBPACK FOOTER //
// ./src/reports/emissions-part-search/components/emissions-part-search-button-group.js